import { Component, Input, NgModule } from '@angular/core';
import { Employee, GetUsersResponseType, Product, SendCustomerInfo } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { MarketPageService } from '../../services/market-page.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginService } from '../../services/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-send-admin-message-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgxCaptchaModule],
  templateUrl: './send-admin-message-modal.component.html',
  styleUrl: './send-admin-message-modal.component.scss'
})
export class SendAdminMessageModalComponent {
  @Input() farmID: number = 0;

  message: string = '';

  constructor(private marketPageService: MarketPageService, public activeModal: NgbActiveModal,) { }

  sendAdminMessage(farmID: number, message: string) {
    if (message.trim() !== '') {
        this.marketPageService.sendAdminMessage(message, farmID).subscribe(
            response => {
                Swal.fire({
                    title: 'Uspešno!',
                    text: 'Sporočilo je bilo uspešno poslano',
                    icon: 'success',
                    confirmButtonText: 'V redu'
                });
                this.activeModal.close();
            },
            error => {
                Swal.fire({
                    title: 'Napaka!',
                    text: 'Prišlo je do napake pri pošiljanju sporočila',
                    icon: 'error',
                    confirmButtonText: 'V redu'
                });
            }
        );
    } else {
        Swal.fire({
            title: 'Opozorilo!',
            text: 'Sporočilo je prazno',
            icon: 'warning',
            confirmButtonText: 'V redu'
        });
    }
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
